__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/da5f616/_next/";